module.exports = __webpack_public_path__ + "static/media/Risorsa 002.5a5ac8e3.svg";